let appDimensions;
try {
  const envVal = process.env.donate_widget_app_dimensions;
  appDimensions = envVal
    ? JSON.parse(envVal)
    : {
        default: { width: 328, height: 360 }
      };
} catch {
  appDimensions = { default: { width: 328, height: 360 } };
}

export default appDimensions;
